import { render, staticRenderFns } from "./vn.vue?vue&type=template&id=7764d5fb&scoped=true"
import script from "./vn.vue?vue&type=script&lang=js"
export * from "./vn.vue?vue&type=script&lang=js"
import style0 from "./vn.vue?vue&type=style&index=0&id=7764d5fb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7764d5fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7764d5fb')) {
      api.createRecord('7764d5fb', component.options)
    } else {
      api.reload('7764d5fb', component.options)
    }
    module.hot.accept("./vn.vue?vue&type=template&id=7764d5fb&scoped=true", function () {
      api.rerender('7764d5fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jackpot/jackpot-physical-prize/vn.vue"
export default component.exports